import { lazy } from "react";
const SourcingRequirement = lazy(
  () =>
    import("@pages/requirementManagement/sourcingRequirementManagement/page"),
);

const PurchaseRequestManagement = lazy(
  () => import("@/pages/requirementManagement/purchaseRequestManagement/page"),
);

const requirementRoute = [
  {
    path: "/requirement",
    name: "需求管理",
    children: [
      {
        path: "/requirement/sourcingRequirementManagement",
        name: "寻源申请管理",
        crumbTitle: "寻源需求管理",
        component: SourcingRequirement,
      },
      {
        path: "/requirement/purchaseRequestManagement",
        name: "采购申请管理",
        crumbTitle: "采购申请管理",
        component: PurchaseRequestManagement,
      },
    ],
  },
];
export default requirementRoute;
